import { EventBus } from '@/helpers/eventBus'
import { createNamespacedHelpers, mapActions } from 'vuex'

const accountController = createNamespacedHelpers('account')

export default {
  props: {
    disabled: {
      type: Boolean,
      default: true
    },
    block_id: {
      type: Number,
      default: 0
    },
    Element_Attributes: {
      type: Array,
      default: function () {
        return []
      }
    },
    Element_Connectors: {
      type: Array,
      default: function () {
        return []
      }
    },
    template_id: {
      type: Number,
      default: 0
    },
    element_id: {
      type: Number,
      default: 0
    },
    isNew: {
      type: Boolean,
      default: false
    },
    ignored: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...accountController.mapGetters(['selectedLanguage', 'selectedLocale', 'selectedLanguageName']),
  },
  methods: {
    ...mapActions(['element_attribute/update', 'element_connector/create']),
    parseBoolean (value) {
      return value != undefined ? (value == 1 || value == '1' || value == true || value == 'true') : false
    },
    getAttribute (attribute_name) {
      let attribute = this.Element_Attributes.find(element_attribute => element_attribute.name == attribute_name)
      return attribute
    },
    updateAttribute (block_id, template_id, element_id, element_attribute) {
      let self = this

      this['element_attribute/update']({
        account_id: self.$route.params.account_id,
        language_id: self.selectedLanguage,
        block_id: block_id,
        template_id: template_id,
        element_id: element_id,
        ...element_attribute,
        callback: async (res) => {
          if (res.error) {
            let res = await this.$bvModal.msgBoxConfirm('Ocurrió un error guardando elemento. ¿Deseas intentarlo de nuevo?', {
              title: 'Error de guardado',
              okVariant: 'primary',
              okTitle: 'Reintentar',
              cancelTitle: 'Cancelar',
              cancelVariant: 'secondary',
              hideHeaderClose: false
            })

            if (res == true) {
              this.updateAttribute.apply(this, arguments)
            }
          }
        }
      })
    },
    createConnector (block_id, template_id, element_id, element_connector) {
      let self = this

      this['element_connector/create']({
        account_id: self.$route.params.account_id,
        language_id: self.selectedLanguage,
        block_id: block_id,
        template_id: template_id,
        element_id: element_id,
        ...element_connector,
        callback: async (res) => {
          if (res.error) {
            let res = await this.$bvModal.msgBoxConfirm('Ocurrió un error creando conector. ¿Deseas intentarlo de nuevo?', {
              title: 'Error creando',
              okVariant: 'primary',
              okTitle: 'Reintentar',
              cancelTitle: 'Cancelar',
              cancelVariant: 'secondary',
              hideHeaderClose: false
            })

            if (res == true) {
              this.createConnector.apply(this, arguments)
            }
          }
        }
      })
    }
  }
}
